import RootNavigation from "./RootNavigation";
export default RootNavigation;
